// @flow

// Libs
import { createSelector } from 'reselect'
import _get from 'lodash/get'

// Selectors
import selectedFieldId$ from './selectedFieldId'
import { fields$, farms$ } from 'fc-assets'

// Constants
import { PROP_ASSET_ID, PROP_LABEL, PROP_PARENT } from 'fc-model-assets'

// Types
import type { Asset } from 'fc-model-assets/types'

export default createSelector(
  [selectedFieldId$, fields$, farms$],
  (
    selectedFieldId: number,
    fields: Array<Asset> = [],
    farms: Array<Asset> = []
  ): string => {
    const { asset: field, label: fieldLabel } = getAssetAndLabel(fields, selectedFieldId)
    const { label: farmLabel } = getAssetAndLabel(farms, field[PROP_PARENT])

    return farmLabel && fieldLabel
      ? `${farmLabel}/${fieldLabel}`
      : ''
  }
)

const getAssetAndLabel = (assets: Array<Asset> = [], id: number): string => {
  const asset = assets.find((asset: Asset): boolean => asset[PROP_ASSET_ID] === id) || {}

  return {
    asset,
    label: _get(asset, PROP_LABEL, ''),
  }
}
